import { Navigate } from 'react-router-dom';
import { SESSION_KEY } from 'hooks/queries/useMeQuery';

export const ProtectedRoute = ({
  isAuth = false,
  children
}: {
  isAuth?: boolean;
  children: React.ReactNode;
}) => {
  const hasSession = !!localStorage.getItem(SESSION_KEY);

  if (!isAuth && !hasSession) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};
